import BaseService from './BaseService.js';

class AdminService extends BaseService {
  users(options, signal) {
    return this.apiGet({
      url: '/companies',
      params: options,
      signal,
    })
  }

  requests(options, signal) {
    return this.apiGet({
      url: '/users-requests',
      params: options,
      signal,
    })
  }

  userDetails(id) {
    return this.apiGet({
      url: `/users/${id}`,
    })
  }

  getStats() {
    return this.apiGet({
      url: '/users-stats',
    })
  }

  getDeletions(activetab = 'stakeholder', params = {}) {
    return this.apiGet({
      url: `/deletions/${activetab}`,
      params,
    })
  }

  getGlobals(entity, params = {}) {
    return this.apiGet({
      url: `/globals/${entity}`,
      params,
    });
  }

  updateGlobal(entity, payload) {
    return this.apiPost({
      url: `/globals/${entity}/update`,
      data: payload,
    });
  }

  mergeGlobal(entity, payload) {
    return this.apiPost({
      url: `globals/${entity}/merge`,
      data: payload,
    });
  }

  checkMergeGlobal(entity, payload) {
    return this.apiPost({
      url: `globals/${entity}/check/merge`,
      data: payload,
    });
  }

  updateAccountAccess(id, data) {
    return this.apiPut({
      url: `/accounts/${id}/access`,
      data,
      isDaf: true,
    });
  }

  updateCompany(id, data) {
    return this.apiPut({
      url: `/companies/${id}`,
      data,
    });
  }

  impersonate(userId) {
    return this.apiGet({
      url: `/impersonate/${userId}`,
    });
  }

  disableUser(userId) {
    return this.apiPut({
      url: `/users/${userId}`,
      data: { status: 'inactive', statusChangeDate: new Date() },
    });
  }

  activateUser(userId) {
    return this.apiPut({
      url: `/users/${userId}`,
      data: {
        status: 'active',
        approvalStatus: 'approved',
        statusChangeDate: new Date()
      },
    });
  }

  resendVerification(userId) {
    return this.apiGet({
      url: `/resend-verification/${userId}`,
    });
  }

  disableCompany(userId) {
    return this.apiPut({
      url: `/companies/${userId}/toggle-status`,
    });
  }

  toggleRequest(id, data) {
    return this.apiPut({
      url: `/users-requests/${id}`,
      data,
    });
  }

  transferRights(id, userId) {
    return this.apiPut({
      url: `/companies/transfer-rights/${id}`,
      data: { userId },
    });
  }

  mergeUser(payload) {
    return this.apiPost({
      url: `companies/merge`,
      data: payload,
    });
  }

  approveAccount(id, payload) {
    return this.apiPut({
      url: `/accounts/${id}/approve`,
      data: payload,
      isDaf: true,
    });
  }

  declineAccount(id, payload) {
    return this.apiPut({
      url: `/accounts/${id}/decline`,
      data: payload,
      isDaf: true,
    });
  }

}

export default new AdminService();
